import { useContext, useEffect } from "react";
import { useNavigate } from "react-router";
import Cookies from "js-cookie";
import UserContext from "../../../contexts/user";
import { API_URL } from "../../../config";

const Logout = () => {
    const navigate = useNavigate();
    const { setUser } = useContext(UserContext);

    useEffect(() => {
        const logout = async() => {
            try {
                await fetch(`${API_URL}/auth/logout`, { method: "DELETE", credentials: "include" });
            } catch(e) {
                console.log(e);
            };
    
            setUser({ loggedin: false, username: null, balance: null });
            Cookies.remove("loggedin");
            Cookies.remove("username");
            Cookies.remove("balance");
            navigate("/");
        };
        logout();
    }, []);

    return (
        <div className="logout">
            <span>Logging out...</span>
        </div>
    );
};

export default Logout;